// Full-document render of the tempurpedic ProductRegistrationPage FORM state:
// PageSkeleton (normal site chrome, default body_class) wrapping
// ProductRegistrationPageBody.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ProductRegistrationPageBody } from "../components/ProductRegistrationPageBody";

// Mutable reactivated props (not Immutable<>): this template composes
// PageSkeleton, which is typed with mutable reactivated props (see
// PageSkeleton). The body accepts Immutable props, to which these are
// assignable.
type IProps = templates.ProductRegistrationPageTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <ProductRegistrationPageBody {...props} />
        </PageSkeleton>
    );
};
